import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtlBysSurecService } from './ctl-bys-surec.service';
import { LabelMode } from 'devextreme/common';
import { DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule } from 'devextreme-angular';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { CtlBysSurecAramaService } from './ctl-bys-surec-arama/ctl-bys-surec-arama.service';
import { CtlBysSurecAramaComponent } from './ctl-bys-surec-arama/ctl-bys-surec-arama.component';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-bys-surec',
  standalone: true,
  imports: [ DxTextBoxModule,
    DxButtonModule,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  CtlBysSurecAramaComponent],
  providers:[CtlBysSurecService],
  templateUrl: './ctl-bys-surec.component.html',
  styleUrls: ['./ctl-bys-surec.component.scss'],

})
export class CtlBysSurecComponent implements OnChanges,OnInit {
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "BysSurec";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: any;
  @Input() birim!: number;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: CtlBysSurecService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['birim']) {
      if(this.birim == null) this.showAction = false
      else{
        this.showAction = true
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
      }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.birim) {
      this.toastMessage = "Birim kodu alınamadı"
      this.showAction = false
    }
    this.service.setParams(this.birim,this.isReadOnly,this.isBindCheck)
  }

  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }


  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code), this.birim,this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
